import React, { useState } from 'react';
import axios from 'axios';
import { host_url } from '../../App'; // Import host_url
import KernteamLayout from '../../KernteamLayout';
import BackArrow from '../../BackArrow';
import './JobsHinzufuegen.css';

function JobsHinzufuegen() {
  const [jobName, setJobName] = useState('');
  const [jobDescription, setJobDescription] = useState('');
//   const [x, setX] = useState('');
//   const [y, setY] = useState('');
  const [ganztagesjob, setGanztagesjob] = useState(false);
  const [ueberstunden, setUeberstunden] = useState(false);
  const [handwerksjob, setHandwerksjob] = useState(false);
  const [mindestanzahl, setMindestanzahl] = useState(2);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${host_url}/jobs`, {
        Name: jobName,
        Beschreibung: jobDescription,
        // X: x,
        // Y: y,
        Ganztagesjob: ganztagesjob,
        Ueberstunden: ueberstunden,
        Mindestanzahl: mindestanzahl,
        Handwerksjob: handwerksjob
      });
      if (response.status === 200) {
        setJobName('');
        setJobDescription('');
        // setX('');
        // setY('');
        setGanztagesjob(false);
        setUeberstunden(false);
        setHandwerksjob(false);
        setMindestanzahl(2);
        setShowSuccessModal(true);
      }
    } catch (error) {
      console.error('Fehler beim Hinzufügen des Jobs:', error);
      alert('Fehler beim Hinzufügen des Jobs');
    }
  };

  return (
    <KernteamLayout>
    <div className="container">
      <BackArrow to="/arbeit" color="gelb" />
      <h1 className="section-title orange">Neuen Job hinzufügen</h1>
      <form onSubmit={handleSubmit} className="jobs-hinzufuegen-form">
        <div className="form-group">
          <label>Jobname</label>
          <input
            type="text"
            value={jobName}
            onChange={(e) => setJobName(e.target.value)}
            placeholder="Gib die Bezeichnung des Jobs ein"
            required
          />
        </div>
        <div className="form-group">
          <label>Beschreibung</label>
          <textarea
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
            placeholder="Beschreibe kurz die Aufgaben, die man bei diesem Job erledigen muss"
            required
          />
        </div>
        {/* <div>
          <label>X Koordinate:</label>
          <input type="number" value={x} onChange={(e) => setX(e.target.value)} />
        </div>
        <div>
          <label>Y Koordinate:</label>
          <input type="number" value={y} onChange={(e) => setY(e.target.value)} />
        </div> */}
        <div className="form-group">
          <label className="checkbox-green">
            <input type="checkbox" checked={ganztagesjob} onChange={(e) => setGanztagesjob(e.target.checked)} />
            Ganztagesjob
          </label>
        </div>
        <div className="form-group">
          <label className="checkbox-green">
            <input type="checkbox" checked={ueberstunden} onChange={(e) => setUeberstunden(e.target.checked)} />
            Überstunden
          </label>
        </div>
        <div className="form-group">
          <label className="checkbox-green">
            <input type="checkbox" checked={handwerksjob} onChange={(e) => setHandwerksjob(e.target.checked)} />
            Handwerksjob
          </label>
        </div>
        <div className="form-group">
          <label>Mindestanzahl Slots</label>
          <input
            type="number"
            min="0"
            value={mindestanzahl}
            onChange={(e) => setMindestanzahl(parseInt(e.target.value) || 0)}
            required
          />
        </div>
        <button type="submit">Job hinzufügen</button>
      </form>
      {showSuccessModal && (
        <div className="jh-success-overlay">
          <div className="jh-success-modal">
            <p>Job erfolgreich hinzugefügt</p>
            <div className="jh-success-buttons">
              <button onClick={() => setShowSuccessModal(false)}>Schließen</button>
              <button onClick={() => { window.open('/jobsmarkieren', '_blank'); setShowSuccessModal(false); }}>
                Auf Karte markieren
              </button>
            </div>
          </div>
        </div>
      )}
    </div>

    </KernteamLayout>
  );
}

export default JobsHinzufuegen;
